import * as React from 'react';
import { Messages } from '../../../codegen/Localize';
import { TextileHelper } from '../../../ts/helpers/TextileHelper';
import { DetailsTooltipStyles } from '../CardView/DetailsTooltipStyles';
import { MarkupField } from '../Components/MarkupField';
import { Name } from './Elements/Name';
import { Timestamp } from './Elements/Timestamp';
import { Tooltip } from './Elements/Tooltip';
import { User } from './Elements/User';
import { ContentTooltipProps, TooltipDescriptionTestId } from './TooltipHelper';

export function removeProjectDescriptionImage(description: string): string {
  // Remove the trailing textile image in the tooltip (this image is only used for setting the project card thumbnail)
  return description
      ? description.replace(TextileHelper.TRAILING_IMAGE, '')
      : description;
}

export function ProjectTooltip(props: ContentTooltipProps): JSX.Element {
  const description = removeProjectDescriptionImage(props.content.description);

  return (
    <Tooltip>
      <Name name={props.content.name} />
      <MarkupField markup={description}
                   testId={TooltipDescriptionTestId}
                   extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      <User user={props.content.owner} label={Messages.owner()} urls={props.urls} />
      <Timestamp label={Messages.modified()} value={props.content.updatedAt} />
    </Tooltip>
  );
}
